import Axios from "axios";

/* const url_categories_dev =; */
import { sortCaret } from "../../../_metronic/_helpers";

const base_url = process.env[`REACT_APP_${process.env.REACT_APP_ENV.toUpperCase()}_URL`] + "/v1/phases";


export const columns = [
  {
    dataField: "name",
    text: "Phase Title",
    sort: true,
    sortCaret: sortCaret,
  },
  {
    dataField: "description",
    text: "Description",
    sort: true,
    sortCaret: sortCaret,
  },
];

export function getClients(setCategory) {
  Axios.get(`${base_url}/find`)
    .then((res) => {
      const categories = res.data.payload;
      console.log(categories);
      setCategory(categories);
    })
    .catch(function (thrown) {
      if (Axios.isCancel(thrown)) {
        console.log(`request cancelled:${thrown.message}`)
      } else {
        console.log('another error happened')
      }
    })
}
export function getClient(uid = "") {
  return Axios.get(`${base_url}/find/${uid}`);
}
export function updateClient(phases) {
  if (phases.uid) {
    return Axios.put(`${base_url}/update/${phases.uid}`, phases);
  } else {
    return Axios.post(`${base_url}/create`, phases);
  }
}
export function deleteClient(uid) {
  return Axios.delete(`${base_url}/delete/${uid}`);
}

export function populate(uids) {
  return Axios.post(`${base_url}/populate`, { uids });

}